<template>
  <section v-lenis-scroll class="takat-left-collection">
    <div class="takatLeftCollection">
      <div class="takatPrefall" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }">
        <div class="takatLeftSide">
          <img
            v-if="shopifyData.layout == 'infoImage'"
            class="tharLeftImage"
            :src="shopifyData.leftTextImage"
            alt="Text Image"
          />
          <p v-else class="leftInfo">
            {{ shopifyData.leftText }}
          </p>
        </div>
        <div class="tharRightInfo">
          <img
            class="tharRightImage"
            :src="shopifyData.rightMiddleImage"
            alt="Right Middle Image"
          />
          <div class="responsiveImage">
            <img
              v-if="shopifyData.layout == 'infoImage'"
              :src="shopifyData.leftTextImage"
              alt="Text Image"
            />
            <p v-else class="leftInfo">
              {{ shopifyData.leftText }}
            </p>
          </div>
        </div>
      </div>
      <div class="tharRightSide">
        <div class="tharProducts">
          <div v-for="(value, key) in shopifyData.productData" :key="key" class="grid_item">
            <a
              v-if="value.showCollection == 'true'"
              :href="value.collectionLink"
              class="product_link"
            >
              <div
                class="tharProductInfo"
                :class="value.showPreview === 'true' ? 'customImage' : ''"
              >
                <h1 class="tharProductTitle">{{ value.product.productTitle }}</h1>
                <div class="tharProductPriceInfo">
                  <span v-if="value.product.compare_at_price > value.product.productidPrice">
                    class="tharProductPrice"
                    <del>
                      {{ currencySymbol }}
                      {{ value.product.compare_at_price }}
                    </del>
                  </span>
                  <span v-if="value.product.productidPrice">
                    class="tharProductPrice"
                    {{ currencySymbol }}
                    {{ value.product.productidPrice }}
                  </span>
                  <span v-if="value.product.compare_at_price > value.product.productidPrice">
                    class="discountPercentage tharProductPrice"
                    {{ value.product.discount_percentage }}
                  </span>
                </div>
              </div>
              <div class="grid_item_img">
                <img
                  v-lazy="
                    value.showPreview == 'true' ? value.previewimage : value.product.productidImage
                  "
                  :alt="value.showPreview === 'true' ? 'Preview Image' : 'Product Image'"
                  loading="lazy"
                  aria-hidden="true"
                  aria-label="Product Image"
                  width=""
                  height=""
                />
              </div>
            </a>

            <a
              v-else
              :href="value.product.productUrl"
              :product-id="value.product.productid"
              class="product_link"
            >
              <div
                class="tharProductInfo"
                :class="value.showPreview === 'true' ? 'customImage' : ''"
              >
                <h2 class="tharProductTitle">{{ value.product.productTitle }}</h2>
                <div class="tharProductPriceInfo">
                  <span v-if="value.product.compare_at_price > '1'" class="tharProductPrice">
                    <del>
                      {{ currencySymbol }}
                      {{ value.product.compare_at_price }}
                    </del>
                  </span>
                  <span v-if="value.product.productidPrice" class="tharProductPrice">
                    {{ currencySymbol }}
                    {{ value.product.productidPrice }}
                  </span>
                  <span
                    v-if="value.product.compare_at_price > '1'"
                    class="discountPercentage tharProductPrice"
                  >
                    {{ value.product.discount_percentage }}
                  </span>
                </div>
              </div>
              <div class="grid_item_img">
                <img
                  v-lazy="
                    value.showPreview == 'true' ? value.previewimage : value.product.productidImage
                  "
                  :alt="value.showPreview === 'true' ? 'Preview Image' : value.product.productTitle"
                  loading="lazy"
                  aria-hidden="true"
                  aria-label="Product Image"
                  width=""
                  height=""
                />
              </div>
            </a>
          </div>
        </div>
        <div class="space" />
      </div>
    </div>
  </section>
</template>

<script>
import { currencyJson } from '@/currency';
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      currencySymbol: currencyJson[window?.Shopify?.currency?.active]?.symbol_native,
    };
  },
  computed: {
    backgroundImage() {
      return this.windowWidth <= 768 ? this.shopifyData.mobBg : this.shopifyData.desktopBg;
    },
  },
  mounted() {
    this.handleResize = () => {
      this.windowWidth = window.innerWidth;
    };
    window.addEventListener('resize', this.handleResize);
    this.currencySymbol = currencyJson[window?.Shopify?.currency?.active]?.symbol_native;
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>
.tharProductTitle,
.tharProductPrice {
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 12.08px;
  font-weight: 400;
  line-height: 10.99px;
  letter-spacing: 0.01em;
  text-align: left;
  color: #000;
}

.tharProductPriceInfo {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
}

.discountPercentage {
  color: red;
}

.tharProductPrice {
  font-weight: 700;
}

.tharProductInfo.customImage * {
  color: #ffff;
}

.tharProductInfo.customImage .discountPercentage {
  color: red;
}

.tharProductInfo.customImage .tharProductPrice del {
  color: grey;
}

.grid_item_img img {
  display: block;
}

.takatPrefall {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  height: 100vh;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
}

.leftInfo {
  font-family: 'PP Editorial New', sans-serif;
  font-style: italic;
  font-size: 20px;
  font-weight: 200;
  line-height: 25.6px;
  letter-spacing: 0.02em;
  text-align: center;
  max-width: 468px;
  width: 100%;
  margin: 0 auto;
  color: #ffff;
}

.tharRightSide {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  position: relative;
  z-index: 4;
  -webkit-transform: translate3d(0, 0, 0);
  /* Safari fix */
  transform: translate3d(0, 0, 0);
  /* Hardware acceleration */
}

.tharRightInfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 71px 20px 81px 20px;
  align-items: center;
  position: relative;
  z-index: 1;
}

.tharLeftImage {
  max-width: 773px;
  width: 100%;
  position: relative;
  z-index: 1;
  /* Ensure stacking order */
}

.tharRightText1 {
  max-width: 452px;
  width: 100%;
  padding-bottom: 47px;
}

.tharRightText3 {
  max-width: 371px;
  width: 100%;
  padding-top: 55px;
}

.tharRightImage {
  max-width: 130px;
  width: 100%;
  position: relative;
  z-index: 1;
}

.takatLeftSide {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 1;
}

.tharProducts {
  display: grid;
  grid-template-columns: 50% 50%;
  position: relative;
  z-index: 9;
  background-color: #eeeff2;
}

.tharProducts img {
  width: 100%;
}

.tharProducts .grid_item {
  position: relative;
}

.grid_item .tharProductInfo {
  position: absolute;
  bottom: 12px;
  left: 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.responsiveImage {
  display: none;
}

@media screen and (max-width: 768px) {
  .takatPrefall {
    width: 100%;
    max-width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: leftInfo;
    grid-template-columns: 1fr;
    position: static;
    height: auto;
    padding-top: 60px;
    background-attachment: fixed;
  }

  .space {
    display: none;
  }

  .tharRightSide {
    grid-template-columns: 1fr;
  }

  .tharLeftImage {
    display: none;
  }

  .responsiveImage {
    display: block;
    padding: 45px 0;
    position: relative;
    z-index: 9;
    text-align: center;
  }

  .tharRightImage {
    max-width: 50px;
  }

  .leftInfo {
    font-size: 14px;
  }

  .responsiveImage img {
    text-align: center;
    max-width: 377px;
    width: 100%;
  }

  .takatLeftSide {
    display: none;
  }

  .tharRightInfo {
    padding: 0 30px;
  }

  .tharProductTitle,
  .tharProductPrice {
    font-size: 8px;
    line-height: 1;
    letter-spacing: 0.01em;
  }

  .grid_item .tharProductInfo {
    bottom: 2px;
    left: 2px;
    padding: 5px;
  }
}
</style>
